export const CONSTANTS = {
    NAME: "@base/properties/p-name",
    INSTANCE_OF: "@base/properties/p-instance-of"
}